<template>
  <template v-if="show">
    <v-navigation-drawer
      class="bg-neutral-50"
      location="right"
      :permanent="true"
      style="border-left: 0;"
    >
      <div id="side-panel" class="px-2 py-4"/>
    </v-navigation-drawer>
  </template>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  setup() {
    return {}
  }
})
</script>
